module.exports = __webpack_public_path__ + "assets/gridview-icon.55b106ed.svg";